export const LOGGED_IN = 'loginSuccess';
export const LOGGED_OUT = 'logoutSuccess';
export const LOGIN_REQUEST = 'login';
export const LOGOUT_REQUEST = 'logout';
export const REFRESH_TOKEN_REQUEST = 'refresh';
export const TOKEN_EXPIRED = 'tokenExpired';
export const TOKEN_VALID = 'tokenValid';
export const USER_EMAIL = 'userEmail';
